export const getMenuCardCoords = store => store.ui.menuCardCoords
export const getAnimateOrders = store => store.ui.animateOrders
export const getActivityViewCurrent = store => id => store.ui.activityViews[id]
export const getActivityViewAnimate = store => store.ui.activityViewAnimate
export const getPageLoaderState = store => store.ui.pageLoading
export const getPromoPopup = store => store.ui.promoPopupToDisplay
